module.exports = __webpack_public_path__ + "static/media/ic_cross.38e220ac.svg";